import { useNavigate } from "react-router-dom";
import { ClipboardCheck, Gift, CalendarClock, Target, ArrowRight } from "lucide-react";
import { appStatus } from "./portal";

export function pickNextStep(apps, interviews, opps) {
  const rows = apps.map((a) => ({ a, s: appStatus(a, interviews) }));
  const offer = rows.find((r) => r.s.key === "offer");
  if (offer) return {
    icon: Gift, eyebrow: "Next step · offer waiting", title: `Respond to your offer for ${offer.a.job?.title}`,
    sub: [offer.a.company_name, offer.a.offer?.compensation].filter(Boolean).join(" · "), cta: "Review offer", to: `/candidate/applications?open=${offer.a.id}`,
  };
  const test = rows.find((r) => r.s.key === "assessment");
  if (test) {
    const j = test.a.job || {};
    return {
      icon: ClipboardCheck, eyebrow: "Next step · assessment", title: `Assessment for ${j.title}${test.a.company_name ? ` at ${test.a.company_name}` : ""}`,
      sub: [j.assessment_time_limit_min ? `~${j.assessment_time_limit_min} min` : "Untimed", "online"].join(" · "),
      cta: test.s.action === "Resume" ? "Resume assessment" : "Start when ready", to: test.s.to,
    };
  }
  const iv = rows.find((r) => r.s.iv);
  if (iv) return {
    icon: CalendarClock, eyebrow: "Next step · interview", title: `Interview for ${iv.a.job?.title}`,
    sub: [iv.s.when, iv.s.iv.mode].filter(Boolean).join(" · "), cta: "Prepare", to: `/candidate/applications?open=${iv.a.id}`,
  };
  const top = (opps || []).find((o) => !o.applied && (o.fit || 0) >= 45);
  if (top) return {
    icon: Target, eyebrow: "Next step · new match", title: `${top.job.title} is a ${Math.round(top.fit)}% fit`,
    sub: [top.company_name, top.job.location].filter(Boolean).join(" · "), cta: "Review & apply", to: `/candidate/jobs?job=${top.job.id}`,
  };
  return null;
}

export function NextStepCard({ step }) {
  const nav = useNavigate();
  if (!step) return null;
  const Icon = step.icon;
  return (
    <section data-testid="home-next-step" aria-label="Your next step"
      className="relative overflow-hidden rounded-2xl border border-primary/30 bg-gradient-to-br from-primary/[0.13] via-primary/[0.04] to-transparent p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-5">
      <span className="hidden sm:flex h-12 w-12 rounded-xl bg-primary text-primary-foreground items-center justify-center shrink-0"><Icon className="h-5 w-5" /></span>
      <div className="min-w-0 flex-1">
        <div className="text-[11px] font-semibold uppercase tracking-[0.12em] text-primary" data-testid="next-step-eyebrow">{step.eyebrow}</div>
        <h2 className="mt-1 text-lg sm:text-xl font-display font-semibold leading-snug" data-testid="next-step-title">{step.title}</h2>
        {step.sub && <p className="text-sm text-muted-foreground mt-0.5">{step.sub}</p>}
      </div>
      <button onClick={() => nav(step.to)} data-testid="next-step-cta"
        className="shrink-0 inline-flex items-center justify-center gap-1.5 h-11 px-5 rounded-xl bg-primary text-primary-foreground font-semibold text-sm hover:brightness-110 active:scale-[0.98] transition-[filter,transform]">
        {step.cta} <ArrowRight className="h-4 w-4" />
      </button>
    </section>
  );
}
